import React from 'react';
import { Link } from 'gatsby';
import clsx from 'clsx';

export const FooterLink = ({ 
  to, 
  children, 
  external = false,
  className = '' 
}) => {
  const baseClasses = 'text-gray-400 hover:text-white transition-colors';

  if (external) {
    return (
      <a 
        href={to}
        target="_blank" 
        rel="noopener noreferrer" 
        className={clsx(baseClasses, className)}
      >
        {children}
      </a>
    );
  }

  return (
    <Link 
      to={to} 
      className={clsx(baseClasses, className)}
    >
      {children}
    </Link>
  );
};